import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import DashboardView from "./DashboardView";
import OnboardingModal, { ONBOARDING_ENABLED } from "../Onboarding/Onboarding";
import PendingInvitationsModal from "../../components/PendingInvitationsModal";
import WorkspaceSwitchedToast from "../../components/WorkspaceSwitchedToast";

const Dashboard = () => {
  const { user, isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();

  const isPreview = searchParams.get("onboarding") === "preview";
  const showOnboarding =
    isPreview || (ONBOARDING_ENABLED && isAuthenticated && user?.onboardingCompleted === false);

  return (
    <div className="relative w-full h-full min-h-screen">
      <DashboardView />
      {showOnboarding && <OnboardingModal preview={isPreview} />}
      {!showOnboarding && <PendingInvitationsModal />}
      <WorkspaceSwitchedToast />
    </div>
  );
};

export default Dashboard;
